<app-classi-service [isError]="true">
  <div class="spen-mod-heading lv-1">
    <h1 class="heading-text">{{ heading }}</h1>
  </div>
  <div class="spen-mod-panel">
    <p>{{ message }}</p>
  </div>
</app-classi-service>
